{
  "logOutButton": "Log out",
  "newCustomerQuestion": "New customer?",
  "createNewCustomer": "Create customer",
  "findCustomerOrDeviceOrUserLabel": "Find customer, device or user",
  "customerScope": "Customer",
  "deviceScope": "Device",
  "deviceHelperText": "Search for a device based on full IMEI",
  "userScope": "User",
  "userHelperText": "Search for a user based on name, email or phone number",
  "searchPlaceholder": "Search ...",
  "errorGettingCustomerOrgsText": "Loading customer organizations failed.",
  "noCustomerOrgsFoundText": "No companies found with the given search text.",
  "customerOrgsTable": {
    "customer": "Customer",
    "tscid": "Tscid",
    "country": "Country",
    "open": "Open"
  },
  "usersTable": {
    "name": "Name",
    "email": "Email",
    "customer": "Customer",
    "open": "Open",
    "inactiveUser": "Inactive"
  },
  "errorGettingDevicesText": "Loading devices failed.",
  "noDevicesFoundText": "No results found. Make sure you got the IMEI right.",
  "errorInvalidDeviceImeiValidationText": "Invalid IMEI search input. IMEI must be 15 or 16 digit number.",
  "noUsersFound": "No users found with the given search text.",
  "errorFetchingUsers": "Loading users failed.",
  "warningMaintenanceModeEnabled": "The system is currently under maintenance and in read-only mode.",
  "devicesTable": {
    "imei": "IMEI",
    "device": "Device",
    "customer": "Customer",
    "open": "Open"
  },
  "portalMaintenanceNotification": {
    "title": "Maintenance notice",
    "message": "Telia Device as a Service / Telia Utstyrsavtale is currently under maintenance. End users cannot log in at the moment. Please avoid making updates in Customer Support Tool until maintenance is complete."
  }
}
